import { InputAdornment, TextField } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({setSearchFilter}) => {

    return (
        <TextField
        label="Filtrer" variant="standard"
        InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon/>
              </InputAdornment>
            )
          }}
        onChange={(e) => setSearchFilter(e.target.value)}></TextField>
    )
}

export default SearchBar